export default __webpack_public_path__ + "static/media/102-tile.25eac45b.svg";